import { render, staticRenderFns } from "./PromotionDetail.vue?vue&type=template&id=7f655cc0&scoped=true"
import script from "./PromotionDetail.vue?vue&type=script&lang=js"
export * from "./PromotionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f655cc0",
  null
  
)

export default component.exports